import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-strong" itemScope itemType="https://schema.org/Organization">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2" data-discover="true" itemProp="url">
            <img 
              src="/images/favicon.png" 
              alt="Crown Jackpot" 
              className="w-10 h-10 object-contain"
              itemProp="logo"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent" itemProp="name">
              Crown Jackpot
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-gray-700 hover:text-pink-600 font-medium transition-colors" data-discover="true">
              Home
            </Link>
            <Link to="/guides" className="text-gray-700 hover:text-pink-600 font-medium transition-colors" data-discover="true">
              Guides
            </Link>
            <Link to="/news" className="text-gray-700 hover:text-pink-600 font-medium transition-colors" data-discover="true">
              News
            </Link>
            <Link to="/reviews" className="text-gray-700 hover:text-pink-600 font-medium transition-colors" data-discover="true">
              Reviews
            </Link>

          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4 glass rounded-lg p-4">
            <Link to="/" className="block text-gray-700 hover:text-pink-600 font-medium" data-discover="true">
              Home
            </Link>
            <Link to="/guides" className="block text-gray-700 hover:text-pink-600 font-medium" data-discover="true">
              Guides
            </Link>
            <Link to="/news" className="block text-gray-700 hover:text-pink-600 font-medium" data-discover="true">
              News
            </Link>
            <Link to="/reviews" className="block text-gray-700 hover:text-pink-600 font-medium" data-discover="true">
              Reviews
            </Link>
            
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;

